import { amplitudeTracker } from './amplitude-tracker';
import { getDateWithTime } from './date';

const COMPANY_EMAIL = 'support@futureproof.app';

const getDeviceType = () => {
    const ua = window.navigator.userAgent;
    
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return 'tablet';
    }
    
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return 'mobile';
    }

    return 'desktop';
};

function createIssueReportLink() {
    const date = getDateWithTime(new Date(Date.now()).toISOString());

    return `mailto:${COMPANY_EMAIL}?subject=Reporting an issue during registration on Futureproof&body=Hello,%0D%0A%0D%0AI encountered an issue while using your service. Here is a description of the problem:%0D%0A%0D%0A%0D%0A%0D%0A[Briefly describe the issue you experienced.]%0D%0A%0D%0A%0D%0A%0D%0AImportant diagnostic information (please do not delete): %0D%0AThis information is anonymized and collected automatically to help us resolve your issue more efficiently.%0D%0A%0D%0APage where the issue occurred: ${window.location.origin}${window.location.pathname}%0D%0ADate and time the issue occurred: ${date}%0D%0ADevice: ${getDeviceType()}%0D%0AOperating System: ${window.navigator.platform}%0D%0ABrowser: ${window.navigator.userAgent}%0D%0ADevice Id - ${amplitudeTracker.getDeviceId()}%0D%0A%0D%0A[Your Name]`;
};

export {
    createIssueReportLink
};
